import { Box } from 'rebass'
import styled from 'styled-components'

export const Container = styled(Box)`
  height: fit-content;
`
